import { useEffect, useRef } from "react";

export const RazorpayButton = ({ buttonId }) => {
  const ref = useRef(null);
  useEffect(() => {
    const form = ref.current;
    if (!form || form.querySelector(`script[data-payment_button_id="${buttonId}"]`)) return;
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/payment-button.js";
    s.setAttribute("data-payment_button_id", buttonId);
    s.async = true;
    form.appendChild(s);
  }, [buttonId]);
  return <form ref={ref} className="razorpay-button-host flex justify-center min-h-[48px]" data-testid="razorpay-payment-button" />;
};
